// extracted by mini-css-extract-plugin
export default {"container":"htg60","badgeWithValue":"P0gSL","isSmall":"s1cb-","isNeutral":"H3eCQ","isAccented":"EJ0fl","text":"Xvpcu","extra":"eRjrA","skeleton-progress":"_2uwvx"};